import type { ReactNode } from 'react'

export const reactNodeToString = (reactNode: ReactNode): string => {
  if (typeof reactNode === 'string') {
    return reactNode.toLocaleLowerCase().replace(/\s+/g, '-')
  } else if (typeof reactNode === 'number' || typeof reactNode === 'boolean') {
    return reactNode.toString()
  } else if (reactNode instanceof Array) {
    return reactNode.map((child) => reactNodeToString(child)).join('')
  }
  return ''
}
